module.exports = __webpack_public_path__ + "media/dancefloor.dc5cda86.mp4";